<template>

</template>

<script>
    export default {
      name: "GuoCaodi.vue",
      mounted: function () {
        window.location.href="https://cloudlark.pingxingyun.com:8180/enterAppli?appliId=852502679081975808&regionId=BJ"
      },
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cczyy/GuoCaodi.vue